export const PLAN_LIMITS = {
  demo: {
    maxProjects: 1,
    researchFilesPerProject: 1,
    researchExtractedTextMax: 12000,
    projectNameMax: 120,
    productDescriptionMax: 2000,
    targetAudienceMax: 160,
    industryContextMax: 160,
  },
  free: {
    maxProjects: 3,
    researchFilesPerProject: 1,
    researchExtractedTextMax: 20000,
    projectNameMax: 120,
    productDescriptionMax: 3000,
    targetAudienceMax: 300,
    industryContextMax: 300,
  },
};

export function getEffectiveUserPlan(user) {
  const plan = String(user?.plan || "").trim().toLowerCase();
  return plan === "demo" ? "demo" : "free";
}

export function getPlanLimitsForUser(user) {
  const plan = getEffectiveUserPlan(user);
  return PLAN_LIMITS[plan];
}
